/** Минимум элементов: при count > значения используется Virtuoso */
export const VIRTUAL_LIST_VIRTUOSO_MIN_COUNT = 25;
export const VIRTUAL_LIST_DEFAULT_ITEM_HEIGHT = 44;
export const VIRTUAL_LIST_DEFAULT_MAX_HEIGHT = 200;
